import { Injectable } from '@angular/core';
import { IOkDialogConfig } from '@app/shared/services/dialogs/ok-dialog/ok-dialog-config';
import { OkDialogResult } from '@app/shared/services/dialogs/ok-dialog/ok-dialog-result.enum';
import { OkDialogComponent } from '@app/shared/services/dialogs/ok-dialog/ok-dialog.component';
import { IYesNoDialogConfig } from '@app/shared/services/dialogs/yes-no-dialog/yes-no-dialog-config';
import { YesNoDialogResult } from '@app/shared/services/dialogs/yes-no-dialog/yes-no-dialog-result.enum';
import { YesNoDialogComponent } from '@app/shared/services/dialogs/yes-no-dialog/yes-no-dialog.component';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DialogsService {
  constructor(private modalService: BsModalService) { }

  showOkDialog(messageTranslationKey: string, customDialogConfig: IOkDialogConfig = {}, messageTranslationKeyArgs: any = {}) {
    const subject = new Subject<OkDialogResult>();

    const defaultConfig: IOkDialogConfig = {
      showIcon: false,
      iconClass: '',
      okButtonTextTranslationKey: 'SHARED.DIALOGS.OK-DIALOG.BUTTON-OK',
      acceptHTML: false,
      dissmissable: true
    };

    this.modalService.show(OkDialogComponent,
      {
        keyboard: false,
        class: 'modal-dialog-centered borderless',
        ignoreBackdropClick: true,
        initialState: {
          subject,
          messageTranslationKey,
          messageTranslationKeyArgs,
          dialogConfig: { ...defaultConfig, ...customDialogConfig }
        }
      });

    return subject.asObservable();
  }

  showYesNoDialog(messageTranslationKey: string, customDialogConfig: IYesNoDialogConfig = {}, messageTranslationKeyArgs: any = {}) {
    const subject = new Subject<YesNoDialogResult>();

    const defaultConfig: IYesNoDialogConfig = {
      showIcon: true,
      iconClass: 'help-circle',
      yesButtonTextTranslationKey: 'SHARED.DIALOGS.YES-NO-DIALOG.BUTTON-YES',
      noButtonTextTranslationKey: 'SHARED.DIALOGS.YES-NO-DIALOG.BUTTON-NO',
      acceptHTML: false,
      cautionMode: false,
      invertButtonsOrder: false,
      dissmissable: true
    };

    this.modalService.show(YesNoDialogComponent,
      {
        keyboard: false,
        class: 'modal-dialog-centered borderless',
        ignoreBackdropClick: true,
        initialState: {
          subject,
          messageTranslationKey,
          messageTranslationKeyArgs,
          dialogConfig: { ...defaultConfig, ...customDialogConfig }
        }
      });

    return subject.asObservable();
  }
}

